import { render, staticRenderFns } from "./SignupFormVersion.vue?vue&type=template&id=3938d768&"
import script from "./SignupFormVersion.vue?vue&type=script&lang=js&"
export * from "./SignupFormVersion.vue?vue&type=script&lang=js&"
import style0 from "./SignupFormVersion.vue?vue&type=style&index=0&id=3938d768&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports